import { Link } from 'react-router-dom';

// Story 110 — player names on public spectator pages link to the
// player's participation page. Renders plain text when no rank is
// available (pre-close lists, TV surfaces simply don't use this).

interface Props {
  slug: string;
  startingRank: number | null | undefined;
  name: string;
  className?: string;
}

export function PlayerNameLink({ slug, startingRank, name, className }: Props) {
  if (startingRank == null) {
    return <span className={className}>{name}</span>;
  }
  return (
    <Link
      to={`/t/${slug}/player/${startingRank}`}
      data-testid={`player-link-${name}`}
      className={
        (className ? className + ' ' : '') +
        'underline-offset-4 hover:underline'
      }
    >
      {name}
    </Link>
  );
}
